jQuery(document).ready(function ($) {
  $('.btn-area').mouseenter(function() {
    $('#page-footer').addClass('is-hover'); 
  }).mouseleave(function() {
    $('#page-footer').removeClass('is-hover');
  });
});